module.exports = __webpack_public_path__ + "static/media/Cancelled.43846eb3.svg";